export const AppPlaceholders = {
	creator_email: '{{creator_email}}',
} as const;

export type AppPlaceholders = (typeof AppPlaceholders)[keyof typeof AppPlaceholders];

export const AppPlaceholdersArray = Object.values(AppPlaceholders) as AppPlaceholders[];
export const AppPlaceholdersTranslationKeys = AppPlaceholdersArray.map(p => `placeholders.${p}`) as string[];

export function isAppPlaceholder(value: string): value is AppPlaceholders {
	return value && AppPlaceholdersArray.includes(value as AppPlaceholders);
}

export function isAppPlaceholderPattern(value: string): boolean {
	return value && AppPlaceholdersArray.some(p => value.includes(p));
}

export function getTranslationKeyForAppPlaceholder(value: string): string | undefined {
	return isAppPlaceholder(value) && AppPlaceholdersTranslationKeys.find(t => t.includes(value));
}
